import { isEmpty, isPlainObject } from 'lodash'
import * as qs from 'qs'

import { GenericalRecord } from '../types/utilities'

const FAKE_URL_PREFIX = 'fake://__a__'
const VALID_URL_REGEXP = /^.*?:\/\/.+/

export const stringify = qs.stringify
export const parse = qs.parse

const fixUrl = (url: string) => {
  return VALID_URL_REGEXP.test(url) ? url : FAKE_URL_PREFIX + url
}

const resolveUrl = (url: string) => {
  return url.replace(FAKE_URL_PREFIX, '')
}

class FakeURL {
  private url: URL
  constructor(url: string) {
    this.url = new URL(fixUrl(url))
  }

  getOrigin() {
    return this.url.origin.replace(FAKE_URL_PREFIX, '')
  }

  getPathname() {
    return this.url.pathname
  }

  getSearch() {
    return this.url.search
  }

  setSearch(search: string) {
    this.url.search = search
  }

  getHash() {
    return this.url.hash
  }

  setHash(hash: string) {
    this.url.hash = hash
  }

  toString() {
    return resolveUrl(this.url.toString())
  }
}

export const stringifyUrl = (
  {
    url,
    query: externalQuery,
    fragmentIdentifier
  }: {
    url: string
    query?: GenericalRecord
    fragmentIdentifier?: string
  },
  options?: qs.IStringifyOptions
) => {
  const uri = new FakeURL(url)

  const queryFromUrl = parse(uri.getSearch(), {
    ignoreQueryPrefix: true
  })
  const search = stringify(
    {
      ...queryFromUrl,
      ...externalQuery
    },
    {
      arrayFormat: 'indices',
      encode: true,
      allowDots: true,
      filter(prefix, value) {
        if (Array.isArray(value) && !isPlainObject(value[0])) {
          return value.length ? value.toString() : undefined
        }
        return value
      },
      ...options
    }
  )
  uri.setSearch(search)

  if (!isEmpty(fragmentIdentifier)) {
    uri.setHash(`#${fragmentIdentifier}`)
  }

  return uri.toString()
}

export const parseUrl = (url: string, options?: qs.IParseOptions) => {
  const uri = new FakeURL(url)

  return {
    url: `${uri.getOrigin()}${uri.getPathname()}`,
    // remove ? symbol
    query: parse(uri.getSearch().slice(1), options),
    // remove # symbol
    fragmentIdentifier: uri.getHash().slice(1)
  }
}
